export const mcqApiUrl:any = 'https://aibackend.netsmartz.us/api/generate_mcqs';
export const chatBotApiUrl:any = 'https://aibackend.netsmartz.us/api/chatbot_tool';

export const speechToTextApiUrl:any = 'https://aibackend.netsmartz.us/api/speech_summarizer'

export const langChainApiUrl:any = 'https://aibackend.netsmartz.us/api/pdf_summarizer'

export const getArticlesApiUrl:any = 'https://aibackend.netsmartz.us/api/get_articles'

export const articleSummarizationApiUrl:any = 'https://aibackend.netsmartz.us/api/summarize'

export const huggingFaceApiUrl:any = 'https://aibackend.netsmartz.us/api/sentiment_analysis';

export const technicalInterviewApiUrl:any = 'https://aibackend.netsmartz.us/api/tech_assesment_prob'

export const technicalInterviewSolutionApiUrl:any = 'https://aibackend.netsmartz.us/api/tech_assesment_sol';

export const codeEvaluationUserApiUrl:any = 'https://aibackend.netsmartz.us/api/generate_code_eval';

// export const codeEvaluationSummaryApiUrl:any = process.env.REACT_APP_CODE_EVALUATION_SUMMARY_API_URL;
export const codeEvaluationSummaryApiUrl:any = 'https://aibackend.netsmartz.us/api/generate_code_sol'

export const translationApiUrl:any =  'https://aibackend.netsmartz.us/api/translation_tool';

export const loginApiUrl:any = `https://aibackend.netsmartz.us/auth/login`;
export const signupApiUrl:any = `https://aibackend.netsmartz.us/auth/register`;
export const emailSentApiUrl:any = `https://aibackend.netsmartz.us/auth/forgot_password`;
export const resetPasswordApiUrl:any =`https://aibackend.netsmartz.us/auth/reset_password`;



export const ProductsSearchApiUrl:any =`https://southcosearch.netsmartz.us/search`;

export const GetProductDetailsApiUrl:any =`https://southcosearch.netsmartz.us/similar_products`;

export const multiTranslationApiUrl:any =  'http://aibackend.netsmartz.us/api/get_file_multilang';

export const multiTransalationTextApiUrl:any =  'http://aibackend.netsmartz.us/api/get_text_multilang';

export const multiTransalationDocApiUrl:any =  'https://aibackend.netsmartz.us/api/get_docs_multilang';


